import React, {useEffect, useState} from "react";
import {Box, Button, Grid, TextField, Typography, useMediaQuery,} from "@mui/material";
import {useTranslation} from "react-i18next";
import moment from "moment";

export default function WebAppDate({
                                       data,
                                       addQuestion,
                                       deleteQuestionsAfterIndex,
                                       goToNextQuestion,
                                       isVisible,
                                       addToUpdateQuestions,
                                       deleteFromQuestionToUpdate,
                                   }) {
    const {t} = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)"); // Check for mobile view
    const today = moment().format("YYYY-MM-DD"); // Get today's date in YYYY-MM-DD format

    const [value, setValue] = useState(data?.currentValue || ""); // Initialize with currentValue from data
    const [showError, setShowError] = useState(false); // Track error state for required fields
    const language = localStorage.getItem("i18nextLng");

    // Initialize value when `currentValue` changes
    useEffect(() => {
        if (data?.currentValue !== undefined) {
            setValue(data.currentValue);
        }
    }, [data?.currentValue]);

    // Handles value updates and external payload behavior
    const handleValue = (newValue) => {
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        setValue(newValue);
        setShowError(false); // Reset error state on value change


    };

    // Handle the "Next" button click
    const handleNextClick = () => {
        if (data && value && value != data.currentValue) {
            addToUpdateQuestions(data, value);
        }

        if (data?.question_object) {

            addQuestion(data?.question_object);
        } else {
            // Otherwise, move to the next question
            goToNextQuestion();
        }

    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <Box style={{padding: "20px"}}>
            {/* Display question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            <Grid container>
                {/* Date Picker */}
                <TextField
                    id="outlined-basic"
                    // placeholder={t("web_app_launch_date")}
                    InputProps={{inputProps: {max: today}}} // Restrict future dates
                    variant="outlined"
                    fullWidth
                    onChange={(e) => handleValue(e.target.value)}
                    type="date"
                    value={value}
                    error={showError}
                    helperText={showError ? t("Please select a valid date.") : ""} // Display error message if required
                />
            </Grid>


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={!value} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>
        </Box>
    );
}
